import { put } from 'redux-saga/effects'
import { fetchLabelsByCompanyAndOperatorAction } from '../../handles'
import { fetchLabelsByCompanyAndOperator, FetchLabelsByCompanyAndOperatorResponse } from '../_http/label'

export function* fetchLabelsByCompanyAndOperatorSaga(
  action: ReturnType<typeof fetchLabelsByCompanyAndOperatorAction.request>
) {
  const { companyId, operatorId } = action.payload
  try {
    const { labels }: FetchLabelsByCompanyAndOperatorResponse = yield fetchLabelsByCompanyAndOperator(
      companyId,
      operatorId
    )
    yield put(fetchLabelsByCompanyAndOperatorAction.success({ labels }))
  } catch (error) {
    yield put(fetchLabelsByCompanyAndOperatorAction.failure())
  }
}
